import timeout from "../../../utils/timeout";
import curry from "ramda/es/curry";

function delay(time, run){
	return (...params) => timeout(() => run(...params), time);
}

export default curry(delay);
